import React from "react";

/** Shared empty state — one look for "nothing here yet" across the app. */
const EmptyState = ({ icon, title, copy, action, className = "" }) => (
  <div className={`wg-empty ${className}`}>
    {icon && <span className="wg-empty__icon">{icon}</span>}
    {title && <p className="wg-empty__title">{title}</p>}
    {copy && <p className="wg-empty__copy">{copy}</p>}
    {action}
  </div>
);

export default EmptyState;
